import { onApplicationMenu, onTopLevelRoutes } from 'core';
import { lazy } from 'react';

onTopLevelRoutes(() => ({
  path: '/tools',
  secure: true,
  component: lazy(() => import('./components/Dashboard')),
}));

onApplicationMenu(() => ({
  group: 'common',
  label: 'tools',
  icon: 'dashboard',
  to: '/tools',
}));
